export function encryptor(str, lsName, rotv){
    if (str != undefined && str != "undefined") {
        var ev=obfuscate(str)
        var ev1 = csh(ev, rotv);
        var ev2 = btoa(ev1);
        var ev3 = btoa(ev2);
        localStorage.setItem(lsName, ev3);
    } else {
        localStorage.setItem(lsName, str);
    }
}
export function decryptor(lsName, rotv) {
    var encval = localStorage.getItem(lsName);
    if (encval != "undefined" && encval != undefined) {
        var evalue = atob(encval);
        var ev2 = atob(evalue);
        var ev1 = csh(ev2, rotv);
        var ev=deobfuscate(ev1)
        return ev;
    } else {
        return encval;
    }
}
export function blurrify(str, rotv){
    if (str != undefined && str != "undefined") {
        var ev=obfuscate(str)
        var ev1 = csh(ev, rotv);
        var ev2 = btoa(ev1);
        var ev3 = btoa(ev2);
        return ev3;
    } else {
        return str
    }
}
export function clearify(encval, rotv) {
    if (encval != "undefined" && encval != undefined) {
        var evalue = atob(encval);
        var ev2 = atob(evalue);
        var ev1 = csh(ev2, rotv);
        var ev=deobfuscate(ev1)
        return ev;
    } else {
        return encval;
    }
}
export function csh(str, amount) {
    if (amount < 0) return csh(str, amount + 26);
    var output = "";
    for (var i = 0; i < str.length; i++) {
        var c = str[i];
        if (c.match(/[a-z]/i)) {
            var code = str.charCodeAt(i);
            if (code >= 65 && code <= 90)
                c = String.fromCharCode(((code - 65 + amount) % 26) + 65);
            else if (code >= 97 && code <= 122)
                c = String.fromCharCode(((code - 97 + amount) % 26) + 97);
        }
        output += c;
    }
    return output;
}
export function GetItem(key) {
    var orgKey = btoa(key);
    var key2 = decryptor(orgKey, -19);
    return key2;
}

export function obfuscate(a) {
    var bytes = []; for (var i = 0; i < a.length; i++) {
        var charCode = a.charCodeAt(i); // pad the string to 3 digits
        charCode = String("000" + charCode).slice(-3); bytes.push(charCode);
    }
    return bytes.join('');
}

export function deobfuscate(a) {
    var string = "";
    var chunks = a.match(/.{1,3}/g);
    for (var i = 0; i < chunks.length; i++) {
        string += String.fromCharCode(parseInt(chunks[i], 10));
    }
    return string;
}
